export default __webpack_public_path__ + "static/media/peknieciaprzed.29f3f6be.jpeg";